<template>
  <div class="panel-body">
    <div class="flex flex-content-center flex-direction-column header-boder mr-b-30 text-plan-normal">
      <div class="flex flex-content-center title text-size-20 font-bold">
        現在ご利用中のプラン
      </div>
      <div class="flex plan-info pd-t-20 pd-b-20  text-center">
        <div class="flex flex-content-start flex-basis-25"></div>
        <div v-if="isBasicPlan" class="flex flex-content-baseline plan-basic-text font-bold flex-basis-50 margin-auto gap-5">
          <span class="text-size-36 text-plan-basic">ベーシック</span>
        </div>
        <div v-if="!isBasicPlan" class="flex flex-content-baseline flex-flow-wrap font-bold flex-basis-50 margin-auto">
          <div class="plan-premium-text full-width">
            <span class="text-size-36">プレミアム</span>
            <span v-if="isPremiumTrial">(トライアル)</span>
            <span v-if="planData && planData.interval === 'month'">（月額払い）</span>
            <span v-if="planData && planData.interval === 'year'">（年額払い）</span>
          </div>
          <span v-if="planData && planData.currentPeriodStart && planData.currentPeriodEnd" class="full-width">期間：{{ planData.currentPeriodStart }} ～ {{ planData.currentPeriodEnd }}</span>
        </div>
        <div class="flex flex-flow-column flex-content-start flex-basis-25 text-primary plan-link">
          <a @click.prevent="openConfirmUssageModal()"><i
              class="icon-toggle-side-menu fa fa-caret-right"></i>ご利用料金の確認</a>
          <a v-if="!isBasicPlan && !isPremiumTrial" @click="handleChangePlan()"><i
              class="icon-toggle-side-menu fa fa-caret-right"></i>ご利用プラン・お支払い方法の変更</a>
          <a v-if="!isBasicPlan && !isPremiumTrial" @click="openCancelContractModal()"><i
              class="icon-toggle-side-menu fa fa-caret-right"></i>解約する</a>
        </div>
      </div>
    </div>
    <div v-if="isBasicPlan" class="flex flex-flow-column flex-content-center gap-15 text-plan-normal">
      <div class="flex flex-flow-column gap-10 font-bold">
        <div class="flex flex-content-baseline gap-10">
          <div class="plan-premium-text flex flex-content-baseline gap-5"><span class="text-size-40">プレミアム</span></div>
          月額 <span class="text-size-40">9,800</span> 円
          <span class="label-normal">(税込 10,780 円)</span>
        </div>
        <div class="flex flex-content-baseline text-size-16 text-center gap-5">
          <i class="fa fa-hand-pointer-o fa-lg fa-custom" aria-hidden="true"></i>
          年額払いの場合は
          <span class="text-size-28">98,000</span> 円
          <span class="text-size-14 label-normal"> (税込 107,800 円)</span>
        </div>
      </div>
      <p class="text-size-45 font-bold mr-t-20">
        初回登録なら<span class="text-dark-red">30日間無料</span>
      </p>
      <p class="text-size-24 font-bold text-center">登録から29日後の解約期限までに解約した場合、料金は一切かかりません。</p>
      <button class="btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100" @click="handleUpgradePlan()">
        30日間無料で登録する
        <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
      </button>
      <p class="text-center">無料トライアルは初めて登録する方が対象です</p>
    </div>
    <div v-if="!isBasicPlan && isPremiumTrial" class="flex flex-flow-column flex-content-center gap-15 text-plan-normal">
      <div class="flex flex-flow-column gap-10 font-bold">
        <div class="flex flex-content-baseline gap-10">
          <div class="plan-premium-text flex flex-content-baseline gap-5"><span class="text-size-40">プレミアム</span></div>
          月額 <span class="text-size-40">9,800</span> 円
          <span class="label-normal">(税込 10,780 円)</span>
        </div>
        <div class="flex flex-content-baseline text-size-16 text-center gap-5">
          <i class="fa fa-hand-pointer-o fa-lg fa-custom" aria-hidden="true"></i>
          年額払いの場合は
          <span class="text-size-28">98,000</span> 円
          <span class="text-size-14 label-normal"> (税込 107,800 円)</span>
        </div>
      </div>
      <div class="trial-premium">
        <div class="flex font-bold gap-5 flex-content-baseline">
          <span class="text-size-24">トライアル終了まで 残り</span>
          <div class="text-size-24" :class="{ 'text-red': premiumTrialDate <= 7, 'text-green': premiumTrialDate > 7 }">
            <span class="text-size-36">{{ premiumTrialDate }}</span>日
          </div>
          <span v-if="premiumTrialEndDate" class="text-size-16">{{ `（${premiumTrialEndDate} 23:59まで）` }}</span>
        </div>
        <span>プレミアムの継続は以下よりお申し込みください</span>
        <span class="text-red" style="width: 60%;">
          トライアルの途中でお申し込みいただいた場合でも、トライアルの残り期間は料金が発生することはありません
        </span>
        <button class="btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100" @click="handleUpgradePlan()">
          プレミアムを継続する
          <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
        </button>
        <span class="text-size-16" style="width: 70%;">なお、トライアルを終了してベーシックプランとなった場合、STOCKCREW倉庫は自動解約となり、プレミアムプラン向けのサービスのご提供は停止させていただきます。</span>
      </div>
    </div>
    <div v-html="replaceHTMLSellerInfo(planHtml)"></div>
    <div v-if="isBasicPlan" class="flex flex-flow-column flex-content-center gap-15 text-plan-normal">
      <p class="text-size-45 font-bold ">
        初回登録なら<span class="text-dark-red">30日間無料</span>
      </p>
      <p class="text-size-24 font-bold ">登録から29日後の解約期限までに解約した場合、料金は一切かかりません。</p>
      <button class="btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100" @click="handleUpgradePlan()">
        30日間無料で登録する
        <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
      </button>
      <p>無料トライアルは初めて登録する方が対象です</p>
    </div>
    <confirm-usage-charge v-if="isShowConfirmUssageModal" @close="closeConfirmUssageModal"></confirm-usage-charge>
    <cancel-contract-modal v-if="isShowCancelContractModal" @confirm="handleCancelContractModal"
      @close="closeCancelContractModal"></cancel-contract-modal>
    <noti-cancel-contract-completed-modal v-if="isShowNotiCancelContractCompletedModal"
      @close="closeNotiCancelContractCompletedModal" :message="`プレミアムを解約しました。`" />
  </div>
</template>
<script>
import MemberPlanService from '@/services/memberplanservice'
import { mapGetters } from 'vuex'
import ConfirmUsageCharge from '@/view/setting/ConfirmUsageChargeModal'
import CancelContractModal from '@/view/setting/CancelContractModal'
import NotiCancelContractCompletedModal from '@/components/ModalAlert'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  components: {
    ConfirmUsageCharge,
    CancelContractModal,
    NotiCancelContractCompletedModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      isShowConfirmUssageModal: false,
      isShowCancelContractModal: false,
      isShowNotiCancelContractCompletedModal: false,
      planHtml: null,
      planData: null
    }
  },

  created () {
    this.getMemberPlanInfo()
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    isPremiumTrial () {
      return this.userInfo.isPremiumTrial
    },
    premiumTrialDate () {
      return this.userInfo.premiumTrialDate
    },
    premiumTrialEndDate () {
      return this.userInfo.premiumTrialEndDate
    }
  },

  methods: {
    replaceHTMLSellerInfo,
    async getMemberPlanInfo () {
      await MemberPlanService.getMemberPlanInfo()
        .then(response => {
          this.planHtml = response.plan_html
          if (response.plan_data) {
            this.planData = response.plan_data
          }
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
      if (this.$route.params.tab === 'plan-info') {
        this.$events.fire('done')
      }
    },
    openConfirmUssageModal () {
      this.isShowConfirmUssageModal = true
      let logParams = {
        name: eventCode.settings.plan_info_tab.click_confirm_ussage_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    async openCancelContractModal () {
      let logParams = {
        name: eventCode.settings.plan_info_tab.click_cancel_contract_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.isShowCancelContractModal = true
    },
    handleUpgradePlan () {
      this.loader = this.$loading.show()
      MemberPlanService.getCheckoutSession()
        .then(response => {
          if (response && response.data) {
            let logParams = {
              name: eventCode.settings.plan_info_tab.click_upgrade_plan_button,
              properties: {}
            }
            EventService.postTrackLog(logParams)
            location.href = response.data
          }
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    handleCancelContractModal () {
      this.loader = this.$loading.show()
      MemberPlanService.cancelSubscription()
        .then(response => {
          this.loader && this.loader.hide()
          this.closeCancelContractModal()
          this.openNotiCancelContractCompletedModal()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.closeCancelContractModal()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })

      let logParams = {
        name: eventCode.settings.plan_info_tab.click_cancel_contract_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    handleChangePlan () {
      this.loader = this.$loading.show()
      MemberPlanService.getCustomerPortalSession()
        .then(response => {
          if (response && response.data) {
            let logParams = {
              name: eventCode.settings.plan_info_tab.click_change_plan_button,
              properties: {}
            }
            EventService.postTrackLog(logParams)
            location.href = response.data
          }
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openNotiCancelContractCompletedModal () {
      $('#myModal').modal('show')
      this.isShowNotiCancelContractCompletedModal = true
    },
    closeConfirmUssageModal () {
      $('#confirm-ussage-charge').modal('hide')
      this.isShowConfirmUssageModal = false
    },
    closeCancelContractModal () {
      $('#cancel-contract-modal').modal('hide')
      this.isShowCancelContractModal = false
    },
    closeNotiCancelContractCompletedModal () {
      let logParams = {
        name: eventCode.settings.plan_info_tab.cancel_contract_completed,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      $('#myModal').modal('hide')
      this.isShowNotiCancelContractCompletedModal = false
      location.reload()
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'plan-info') {
      let logParams = {
        name: eventCode.settings.plan_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
  .header-boder {
    border: 1px solid #ddd;
  }
  .title {
    padding: 5px 0;
    width: 100%;
    background-color: #deebf7;
  }
  .plan-info {
    width: 100%;
  }
  .plan-basic-text {
    color: #000;
  }
  .text-primary {
    color: #008CC6;
  }
  .fa-custom {
    color: darksalmon;
    transform: rotate(45deg);
  }
  .fa-caret-right:before {
    margin-right: 5px;
  }
  .trial-premium {
    display: flex;
    flex-direction: column;
    background-color: #e8f5e9;
    width: 90%;
    align-items: center;
    padding: 10px;
    text-align: center;
    gap: 10px;
    font-size: 20px;
  }
  .text-green {
    color: #388e3c;
  }
  @media (max-width: 768px) {
    .plan-link {
      margin-left: 20px;
    }
  }
  @media (max-width: 1024px) {
    .plan-link {
      margin-left: 20px;
    }
  }
  @media (max-width: 425px) {
    .text-size-45 {
      font-size: 24px;
    }
    .text-size-40 {
      font-size: 20px;
    }
    .text-size-36 {
      font-size: 22px;
    }
    .text-size-28 {
      font-size: 16px;
    }
    .text-size-20 {
      font-size: 14px;
    }
    .text-size-22 {
      font-size: 16px;
    }
    .text-size-24 {
      font-size: 14px;
    }
    .text-size-16 {
      font-size: 12px;
    }
    .text-size-14 {
      font-size: 12px;
    }
    .pd-r-100 {
      padding-right: 30px;
    }
    .pd-l-100 {
      padding-left: 30px;
    }
    .gap-10 {
      gap: 0;
    }
  }
  @media (max-width: 992px) {
    .plan-info {
        flex-flow: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/setting/PlanInfo.vue